import { render } from "./ManejoIA.vue?vue&type=template&id=e440eb08&scoped=true"
import script from "./ManejoIA.vue?vue&type=script&lang=js"
export * from "./ManejoIA.vue?vue&type=script&lang=js"

import "./ManejoIA.vue?vue&type=style&index=0&id=e440eb08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e440eb08"]])

export default __exports__